














































































































































import { computed, defineComponent, ref } from "@vue/composition-api";
import { useMainStore } from "@/store/storage";
import ClientList from "@/views/clients/ClientList.vue";
import ProjectList from "@/views/projects/ProjectList.vue";
import { Client, Project, Report } from "@/interfaces/interfaces";
import { db } from "@/firebase/firebase";

export default defineComponent({
  name: "ReportPage",
  components: {
    ClientList,
    ProjectList
  },
  setup(props, context) {
    const main = useMainStore();

    const dialog = ref(false);
    const clientId = ref(main.state.clientData.id);
    const projectId = ref(main.state.projectData.id);
    const fullscreen = ref(context.root.$vuetify.breakpoint.mobile);
    const projects = ref(main.state.projects);
    const formProjectId = ref(null);

    async function getReports(id: string) {
      if (id) {
        console.log("functiongetReports -> id", id);

        main.state.reports = [];

        await db
          .collection("projects")
          .doc(id)
          .collection("reports")
          .orderBy("inspectionArea")
          // .onSnapshot((snapshot) => {
          .get()
          .then((docs) => {
            const reports = [] as Report[];
            docs.forEach((item) => {
              reports.push({ ...item.data(), id: item.id } as Report);
            });
            main.state.reports = reports;
          });
      }
    }

    const setProjectId = computed(() => {
      //ERROR PRODUCED DEBUG
      console.log(
        "setProjectId -> main.state.projectData.id",
        main.state.projectData.id
      );
      projectId.value = main.state.projectData.id;
      return main.state.projectData;
    });

    const clientHasProjects = computed(
      // () => projectsFilteredByClientId.value.length > 0
      () => {
        const tester = !!main.state.projectData.id;
        return tester;
      }
    );
    const countReports = computed(() => {
      const len = main.state.reports.length;
      return len;
    });

    const projectsFilteredByClientId = (): Project[] => {
      const projects = main.state.projects.filter((item) => {
        return main.state.clientData.id === item.clientId;
      });
      return projects;
    };

    function CheckReportAndReload() {
      // report
      main.state.reports = [];
    }
    async function findProject() {
      if (projectId.value) {
        const projectData = projects.value.find(
          (item) => item.id === projectId.value
        );
        main.state.projectData = projectData as Project;
        console.log("project id------", projectId.value);
        console.log("projectData-----", main.state.projectData.name);
        if (main.state.projectData) {
          main.state.showBatchForm = true;
          await getReports(main.state.projectData.id as string);
          console.log("reports------", main.state.reports);
        } else {
          // main.resetReportData();

          main.state.showBatchForm = false;
        }
      }
    }

    async function findClient() {
      if (clientId.value) { 
      CheckReportAndReload();
      // formProjectId.value.trigger('change')
      main.state.showBatchForm = false;
      projectId.value = null;
      console.log("findClient -> projectId.value", projectId.value);

      const clientData = main.state.clients.find(
        (item) => item.id === clientId.value
      );
      main.state.clientData = clientData as Client;

      const projectList: Project[] = projectsFilteredByClientId();
      main.state.showProjectSelect = false;
      if (projectList.length > 0) main.state.showProjectSelect = true;
      projects.value = projectList;
      findProject();

      // console.log("######", projectsFilteredByClientId(),  main.state.showProjectSelect );

      // main.resetProjectData();
      // projectId.value = main.state.projectData.id;

      // console.log("functiongetReports ->   main.state.projectData",   main.state.projectData)
      // // console.log("functiongetReports -> projects.value", projects.value);
      }
    }

    findClient();
    findProject();

    return {
      mainState: main.state,
      clientHasProjects,
      dialog,
      fullscreen,
      clientId,
      projectId,
      projectsFilteredByClientId,
      projects,
      setProjectId,
      findProject,
      findClient,
      countReports,
      formProjectId
    };
  }
});
